module.exports = __webpack_public_path__ + "static/img_4583-bcaae2b4277729c209e6dd66b6c9b79c.webp";